var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "summary-controls" },
    [
      _c(
        "b-modal",
        {
          attrs: {
            type: "warn",
            title: "Confirm Cancellation",
            "ok-title": "Confirm"
          },
          on: { ok: _vm.clickConfirmCancel },
          model: {
            value: _vm.showConfirmCancel,
            callback: function($$v) {
              _vm.showConfirmCancel = $$v
            },
            expression: "showConfirmCancel"
          }
        },
        [
          _c("p", [
            _vm._v("Please enter a reason for cancelling the social post:")
          ]),
          _vm._v(" "),
          _c("b-form-textarea", {
            ref: "refTextConfirmCancel",
            attrs: {
              id: "textConfirmCancel-" + _vm.deliverableDetail.id,
              rows: "3"
            },
            model: {
              value: _vm.textConfirmCancel,
              callback: function($$v) {
                _vm.textConfirmCancel = $$v
              },
              expression: "textConfirmCancel"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "action-buttons" },
        _vm._l(_vm.validActions, function(action) {
          return _c(
            "b-button",
            {
              key: "action-button-" + action,
              staticClass: "action-button",
              style: {
                background: _vm.getAction(action).color,
                "border-color": _vm.getAction(action).color
              },
              attrs: { disabled: _vm.buttonsDisabled },
              on: {
                click: function($event) {
                  return _vm.clickActionButton(action)
                }
              }
            },
            [
              _vm._v(
                "\n        " + _vm._s(_vm.getAction(action).name) + "\n      "
              )
            ]
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }